export default __webpack_public_path__ + "1.17.16/static/media/LibreDataShare_Arabic.edfd9310.svg";